import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  flex?: Boolean;
  hide?: Boolean;
}

export const Root = styled.div`
  flex: 1;
  display: flex;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
`

export const AllLoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const EndContainer = styled.div`
`

export const LoaderContainer = styled.div`
`

export const HasNoDesignsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 40px 13px 0px 13px;
`

export const TabNoDesignsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 13px 13px 0px 13px;
`

export const EmptyIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 220px;
  max-width: 220px;
  max-height: 240px;
  overflow: hidden;
  margin: 0px 50px 0px 0px;
`

export const EmptyIconScale = styled.div`
  transform: scale(0.55);
`

export const EmptyTextContainer = styled.div`
`

export const EmptyTitle = styled.div`
  max-width: 455px;
  padding: 30px 0px 30px 0px;
  font-family: Roboto;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.BLUE};
`

export const EmptySubtitle = styled.div`
  max-width: 417px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const TabEmptySubtitle = styled.div`
  max-width: 327px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const EmptyButton = styled.div`
  margin: 26px 0px 0px 0px;
`

export const DesignsContainer = styled.div`
  box-sizing: border-box;
  padding: 32px 14px 0px 14px;
  width: 100%;
  position: relative;
`

export const DesignsWrap = styled.div`
  .group-list {
    padding: 0px 8px 0px 0px;
    display: ${(props: IRootProps) => props.flex ? 'grid' : 'unset'};
    grid-template-columns: ${(props: IRootProps) => props.flex ? 'repeat(auto-fill, 230px)' : 'unset'};
    justify-content: ${(props: IRootProps) => props.flex ? 'space-between' : 'unset'};
  }
`

export const Result = styled.div`
  margin: 0px 6px 23px 19px;
  font-size: 25px;
  font-weight: normal;
  color: ${C.DARK_BLUE};
  display: ${(props: IRootProps) => props.hide ? 'none':'block'};
`;

export const Counter = styled.span`
    font-size: 15px;
    font-weight: normal;
    color: #8891a0;
    margin-left: 24px;
`;

export const Orderby = styled.span`
  font-size: 15px;
  font-weight: normal;
  color: #8891a0;
  float: right;
`;